import config from "config";
import PodcastPageConfig from "pages/podcast/config";
import { getPodcastThemeToken } from "services/utils/getPodcastThemeToken";
//ui
import { Box, Flex, Text, Image } from "@chakra-ui/react";
import { PodcastIconButton } from "./PodcastIconButton";
import { DiscordFilledIcon, TwitterFilledIcon, TelegramIcon, GithubIcon } from "components/icons";
import PodcastColorTypes from "types/podcastColorTypes";

export function PodcastFooter() {
  return (
    <Flex width="100%" position="relative" font="sora" marginTop="auto" bg={getPodcastThemeToken(PodcastColorTypes.FooterBackground)} color={getPodcastThemeToken(PodcastColorTypes.FooterText)}>
      <Box maxWidth="1384px" width="100%" margin="auto" pt={{ base: "41px", md: "94" }} pb={{ base: "40px", md: "0px" }} px={{ base: "39px", sm: "32px" }}>
        <Flex justifyContent="space-between" mb="80px" flexDir={{ base: "column", md: "row" }} alignItems={{ base: "center", md: "flex-start" }}>
          <Flex mr="30px" alignItems="center">
            {config.logoUrl && <Image width={{ base: "48px", md: "96px" }} height={{ base: "48px", md: "96px" }} src={config.logoUrl} />}
            {config?.title && (
              <Text color="inherit" ml="16px" fontWeight="600" fontSize={{ base: "24px", md: "32px" }} lineHeight={{ base: "32px", md: "40px" }} letterSpacing="-0.02em">
                {config.title}
              </Text>
            )}
          </Flex>
          <Flex flexDir="column" maxWidth="650px" width="100%" alignItems={{ base: "center", md: "flex-start" }}>
            {PodcastPageConfig.subscription}
            <Flex mt={{ base: "16px", md: "38px" }} maxWidth="239px" width="100%" justifyContent="space-between">
              <PodcastIconButton name="twitterName" Icon={TwitterFilledIcon} color="white" margin="15px" width="32px" height="32px" label="go-to-my-twitter-page" />
              <PodcastIconButton name="discordName" Icon={DiscordFilledIcon} color="white" margin="15px" width="32px" height="32px" label="go-to-my-discord" />
              <PodcastIconButton name="telegramName" Icon={TelegramIcon} color="white" margin="15px" width="32px" height="32px" label="go-to-my-telegram" />
              <PodcastIconButton name="githubName" Icon={GithubIcon} color="white" margin="15px" width="32px" height="32px" label="go-to-my-github-page" />
            </Flex>
          </Flex>
        </Flex>
        {config.companyDetails && (
          <Flex borderTop="1px solid white" py="24px" alignItems="center" justifyContent="center" display={{ base: "none", md: "flex" }}>
            <Text maxWidth="389px" textAlign="center" fontSize="12px" color="inherit" lineHeight="16px">
              {config.companyDetails}
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
  );
}
